import NavHeader from "../components/NavHeader";
import CourseEditor from "./CourseEditor";

export default function CourseEdit() {
  return (
    <>
      <NavHeader la={"back"} label={"Edit Course"} />

      <CourseEditor />
    </>
  );
}
